import { put, call } from 'redux-saga/effects';
import { map, omit } from 'lodash';
import moment from 'moment';
import mulesoftDataService from '../../services/mulesoftData.services';
import { constants } from '../../constants';

import { 
  restExamDetails,
  updateExamDetailsFlag,
  toggleAlertShowStatus,
  setShowLoaderStatus} from '../actions';

export default function * saveExamDetails (args) {
  try {
    const examDetailsList = map(args.payload.qualifications, (eachExamDetails) => {
      return {
          candidateNumber: eachExamDetails.candidateNumber,
          centreNumber: eachExamDetails.examCenterID,
          centreName: eachExamDetails.examCenter,
          examSeries: moment(`${eachExamDetails.examSeries.month}-${eachExamDetails.examSeries.year}`,
          'MMMM-YYYY').format('MMMM YYYY'),
          name: eachExamDetails.exam
      }
    })
    yield call([mulesoftDataService, 'saveExamDetails'], omit(
      {...args.payload, qualifications: examDetailsList},
     ['callback']));

    //making sure redux store will update if api save is successful
    yield put(updateExamDetailsFlag());
    yield put(setShowLoaderStatus(false));
    args.payload.callback();
  } catch (error) {
    yield put(toggleAlertShowStatus({
      showAlert: true,
      alertVarient:'danger',
      alertMessage: constants.APP_MESSAGE.API_SAVE_ERROR
    }));

    // reseting personal info redux state when api error
    yield put(restExamDetails());
    yield put(setShowLoaderStatus(false));
  }
}
